/**
 * レバウェルスカウト同時登録の「表示条件」を判定する純粋関数。
 *
 * store / Vue に依存しないため、そのまま Vitest で網羅テストできる。
 * 値の取得（store → form への詰め替え）は呼び出し側（scoutMixin）の責務。
 * 条件はデータ（condition）として渡し、判定ロジックは固定。
 */

/**
 * フォーム入力が同時登録の表示条件を満たすか判定する。
 *
 * @param {Object} form 判定対象のフォーム値（各値は Number）。
 * @param {number} form.prefectureId      都道府県ID
 * @param {number} form.licenseTypeId     資格 type_id
 * @param {number} form.workstyleTypeId   雇用形態 type_id
 * @param {number} form.jobchangeTypeId   転職時期 type_id
 * @param {Object} condition 表示条件の定義（scoutCondition.js）
 * @param {number[]} condition.prefectures 対象の都道府県ID
 * @param {number[]} condition.licenses 対象の資格 type_id
 * @param {Array<{workstyles: number[], jobchanges: number[]|null}>} condition.workstyleTiming
 *        雇用形態×時期のOR条件（workstyles は同一扱いする雇用形態 type_id の集合。
 *        jobchanges が null の場合は時期不問）
 * @returns {boolean} 表示条件を満たすなら true
 */
export function matchScoutCondition(form, condition) {
  // エリア（都道府県）が対象外なら表示しない
  if (!condition.prefectures.includes(form.prefectureId)) {
    return false;
  }

  // 資格が対象外なら表示しない
  if (!condition.licenses.includes(form.licenseTypeId)) {
    return false;
  }

  // 雇用形態×時期のいずれかの組み合わせに合致すれば表示
  return condition.workstyleTiming.some((rule) => (
    rule.workstyles.includes(form.workstyleTypeId)
    && (rule.jobchanges === null || rule.jobchanges.includes(form.jobchangeTypeId))
  ));
}
